import * as React from 'react';
import { MediumHeader } from '@narvar/nth-bit-header';
import { useTheme, withThemeProvider } from '@narvar/nth-hook-theme';

interface Props {
  name?: string;
  locationType?: string | null;
  addressLine1: string;
  addressLine2: string;
  containerStyle?: React.CSSProperties;
}

const LocationAddress: React.FunctionComponent<Props> = ({
  name,
  locationType,
  addressLine1,
  addressLine2,
  containerStyle,
}: Props) => {
  const { bodytextDefaultNone } = useTheme();

  return (
    <div style={containerStyle}>
      <div style={{ marginBottom: '0.25rem' }}>
        <MediumHeader as="h3">{name}</MediumHeader>
        {locationType && <div style={bodytextDefaultNone}>{locationType}</div>}
      </div>
      <div style={bodytextDefaultNone}>{addressLine1}</div>
      <div style={bodytextDefaultNone}>{addressLine2}</div>
    </div>
  );
};

export default withThemeProvider(LocationAddress, {
  themeTokens: ['bodytextDefaultNone'],
});
